import { createClientRequestId } from "../../utils/clientRequestId";

export function getRiderDeviceInstanceId() {
  const key = "apparify:rider:device-instance";
  let value = localStorage.getItem(key);
  if (!value) {
    value = window.crypto?.randomUUID?.() || createClientRequestId("rider_device");
    localStorage.setItem(key, value);
  }
  return value;
}
